import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEdit, FaCheck } from 'react-icons/fa';
import Notification from '../shared/Notification';
import styles from './reset-password.module.css';

const ResetPassword = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const storedEmailOrPhone = sessionStorage.getItem('verifyEmailOrPhone') || '';
    const [originalEmailOrPhone, setOriginalEmailOrPhone] = useState(storedEmailOrPhone);
    const [formData, setFormData] = useState({ emailOrPhone: storedEmailOrPhone, verificationCode: '' });
    const [newFormData, setNewFormData] = useState({ emailOrPhone: storedEmailOrPhone, newPassword: '' });

    const [isVerifyDisabled, setIsVerifyDisabled] = useState(false); 
    const [notification, setNotification] = useState('');
    const [setPasswordSegment, setSetPasswordSegment] = useState(true);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (e.target.name === 'emailOrPhone' && e.target.value !== originalEmailOrPhone) {
            setIsVerifyDisabled(true); // Disable verify button if email or phone is edited
        }
    };

    const handleChangeNewPassword = (e) => {
        setNewFormData({ ...newFormData, [e.target.name]: e.target.value });
    };


    const handleEditClick = () => {
        setIsEditing(true); // Enable editing mode
        setIsVerifyDisabled(true); // Disable verify button when editing
    };

    const handleBlur = () => {
        setIsEditing(false); // Disable editing mode on blur
        if (formData.emailOrPhone === originalEmailOrPhone) {
            setIsVerifyDisabled(false); // Enable verify button if no changes
        }
        handleResend(); // Automatically submit on blur
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/authApplicant/verify-forget-password-code', formData);
            console.log(response.data);
            const { token } = response.data;
            localStorage.setItem('token', token);
            // localStorage.setItem('notification', 'Email Verified ! Please set your new password.');
            sessionStorage.removeItem('verifyEmailOrPhone');
            if(response.data.success){
                setSetPasswordSegment(false);
                setNotification('Verification successful! Please set your new password.');
            }
        } catch (error) {
            // console.error(error);
            setNotification(error.response.data.message);
        }
    };
    const handleSubmitNewPassword = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/authApplicant/reset-password',{
                token: localStorage.getItem('token'),
                newPassword: newFormData.newPassword
            });
            // console.log(response.data);
            const { token } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('notification', 'Password reset successful !');
            sessionStorage.removeItem('verifyEmailOrPhone');
            navigate('/home');
        }
        catch (error) {
            // console.error(error);
            setNotification(error.response.data.message);
        }
    }

    const handleResend = async () => {
        setNotification('Resending Verification Email...1');
        setIsVerifyDisabled(false); // Enable verify button after resend
        try {
            let payload = {};
                if(originalEmailOrPhone===formData.emailOrPhone){
                    payload = { emailOrPhone: originalEmailOrPhone,
                    newEmailOrPhone: formData.emailOrPhone};
                    // console.log('originalEmailOrPhone1', originalEmailOrPhone, 'formData.emailOrPhone', formData.emailOrPhone);
                }
                else{
                    payload = { emailOrPhone: originalEmailOrPhone,
                    newEmailOrPhone: formData.emailOrPhone};
                    //  console.log('originalEmailOrPhone2', originalEmailOrPhone, 'formData.emailOrPhone', formData.emailOrPhone);
                }
            setOriginalEmailOrPhone(formData.emailOrPhone);
            sessionStorage.setItem('verifyEmailOrPhone',formData.emailOrPhone);
            const response = await axios.post('/api/authApplicant/resend-forget-password', payload);
            // console.log(response.data);
            if(response.data.success){
                setNotification('Verification code sent.');
            }
        } catch (error) {
            // console.error(error);
            // setNotification(error.response.data.message);
        }
    };
    const handleCloseNotification = () => {
        setNotification('');
    };
    return (
        <>
        {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}
        <div className={styles.verifyContainer}>
        {setPasswordSegment ? (
            <form onSubmit={handleSubmit} noValidate className={styles.verifyForm}>
                <h2>Reset Password</h2>
                <div className={styles.editableField}>
                    {isEditing ? (
                        <input
                            type="text"
                            name="emailOrPhone"
                            value={formData.emailOrPhone}
                            onChange={handleChange}
                            onBlur={handleBlur} // Exit editing mode when input loses focus
                            autoFocus
                        />
                    ) : (
                        <p className={styles.infoText}>
                            Verification Code sent to: <strong>{formData.emailOrPhone}</strong>
                            <FaEdit className={styles.editIcon} onClick={handleEditClick} />
                        </p>
                    )}
                </div>

                <input
                    type="text"
                    name="verificationCode"
                    placeholder="Verification Code"
                    value={formData.verificationCode}
                    onChange={handleChange}
                    required
                />
                <div className="error-message">
                    <p>{error}</p>
                </div>
                <button type="submit" className={styles.verifyButton} disabled={isVerifyDisabled}>Verify</button>
                <button type="button" className={styles.resendButton} onClick={handleResend}>
                    Resend Verification Code
                </button>
            </form>
            ):(
            <form onSubmit={handleSubmitNewPassword} noValidate className={styles.verifyForm}>
                <h2>Setting New Password</h2>
                <div className={styles.editableField}>
                    <p className={styles.infoText}>
                            <strong>{newFormData.emailOrPhone}</strong> Email Verified 
                        <FaCheck className={styles.editIcon}/>
                    </p>
                </div>
                <div className={styles.enterPasswordContainer}>
                    <input
                        type={showNewPassword ? "text" : "password"}
                        name="newPassword"
                        placeholder="Enter New Password"
                        value={newFormData.newPassword}
                        onChange={handleChangeNewPassword}
                        required
                        className={styles.newPasswordInput}
                    />
                    <span 
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        className={styles.eyeIcon}
                    >
                    {showNewPassword ? '👁️' : '👁️‍🗨️'}
                    </span>
                </div>
                <div className="error-message">
                    <p>{error}</p>
                </div>
                <button type="submit" className={styles.verifyButton} disabled={isVerifyDisabled}>Reset Password</button>
                {/* <button type="button" className={styles.resendButton} onClick={handleResend}>
                    Resend Verification Code
                </button> */}
            </form>)}
        </div>
        </>
    );
};

export default ResetPassword;
